<div class="dx-currency-cell" [ngClass]="highlightClass">
  {{value}}
</div>

